import { useEffect, useRef, useState } from "react";

import { sendLog } from "@/businessLogics/_common/logging";

import * as C from "./components";
import * as D from "./data";
import * as S from "./style";

export let curriculumRef;
export default function Template({ course }: { course: string }) {
  curriculumRef = useRef();
  const [isLogSent, setIsLogSent] = useState(false);
  const curriculumObj = {
    pm: D.pmCurriculums,
    mkt: D.mktCurriculums,
  };
  const lastStepIdxObj = { pm: 4, mkt: 6 };

  useEffect(() => {
    if (isLogSent) return;
    if (curriculumRef.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            sendLog("sw_PM_curridetailDiv_view");
            setIsLogSent(true);
            observer.disconnect();
          }
        },
        { threshold: [0.3, 0.5] }
      );
      observer.observe(curriculumRef.current);
      return () => {
        observer.disconnect();
      };
    }
  }, [isLogSent]);

  return (
    <S.Section id={"curriculums"} ref={curriculumRef}>
      <S.Article>
        <S.Title>
          <D.Title course={course} />
        </S.Title>
        <S.Curriculums>
          {curriculumObj[course].map((curriculum, idx) => (
            <S.Curriculum key={idx}>
              <C.Curriculum
                course={course}
                curriculum={curriculum}
                seq={course === "mkt" ? idx - 1 : idx}
                offset={idx === curriculumObj[course].length ? 10 : 90}
                idx={idx}
                lastStepIdx={lastStepIdxObj[course]}
              />
            </S.Curriculum>
          ))}
        </S.Curriculums>
      </S.Article>
      <S.Info>
        * 커리큘럼은 수강생의 이해도 및 수강환경에 따라
        <br />
        일정 부분 변경될 수 있습니다.
      </S.Info>
    </S.Section>
  );
}
